import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Skeleton, Typography } from '@mui/material';
import React from 'react';

const InfoCurrentPeriodicalReport = ({ currentPeriodicalReport, isLoading }) => {
  return (
    <div className='py-1 px-4 max-w-180px min-w-180px absolute top-0px bottom-0px left-0px flex flex-col justify-center overflow-auto bg-primary'>
      <Typography variant='subtitle1' component={'div'} className='font-bold text-small text-primary-foreground text-nowrap text-ellipsis max-w-180px'>
        { currentPeriodicalReport.isCurrent && <FontAwesomeIcon icon='star' className='text-accent-foreground mr-2' /> }
        {isLoading ? <Skeleton width={120} /> : <span>{currentPeriodicalReport?.name}</span>}
      </Typography>
      <Typography variant='body' component={'p'} className='font-bold text-xs uppercase text-primary-foreground opacity-90'>
        {isLoading ? <Skeleton width={70} /> : currentPeriodicalReport?.status?.replace(/-/g, ' ')}
      </Typography>
    </div>
  );
};

export default InfoCurrentPeriodicalReport;
